// extracted by mini-css-extract-plugin
module.exports = {"container":"SaveFooter_container__rvnzg","button":"SaveFooter_button__1NGfZ","label":"SaveFooter_label__2Fiol"};